// Website enquiries — what people send from the orio360.com form (website plan
// D3, §6.3). Mirrors `enquiries` (migration 20261231220000).

export const ENQUIRY_STATUSES = ['NEW', 'CONTACTED', 'CONVERTED', 'CLOSED'] as const;
export type EnquiryStatus = (typeof ENQUIRY_STATUSES)[number];

export const ENQUIRY_INTERESTS = ['DEMO', 'TRIAL', 'PRICING', 'SUPPORT', 'OTHER'] as const;
export type EnquiryInterest = (typeof ENQUIRY_INTERESTS)[number];

export const ENQUIRY_BUSINESS_TYPES = ['RETAIL', 'RESTAURANT', 'OTHER'] as const;
export type EnquiryBusinessType = (typeof ENQUIRY_BUSINESS_TYPES)[number];

/** The team email's outcome; null until the send has finished. */
export type EnquiryNotifyStatus = 'SENT' | 'FAILED' | 'SKIPPED';

/** GET /platform/enquiries/:id — every column. */
export interface Enquiry {
  id: string;
  name: string;
  business_name: string | null;
  contact_email: string;
  phone: string;
  business_type: EnquiryBusinessType | null;
  city: string | null;
  plan_name: string | null;
  interest: EnquiryInterest;
  message: string | null;
  source_page: string | null;
  consent_at: string;
  status: EnquiryStatus;
  notes: string | null;
  handled_by: string | null;
  contacted_at: string | null;
  converted_tenant_id: string | null;
  notify_status: EnquiryNotifyStatus | null;
  ip: string | null;
  user_agent: string | null;
  created_at: string;
  updated_at: string;
}

/** GET /platform/enquiries/summary */
export interface EnquirySummary {
  by_status: Record<EnquiryStatus, number>;
  new_last_7_days: number;
}

/** GET /platform/enquiries filters. `from` / `to` are days (YYYY-MM-DD), both included. */
export interface EnquiryFilters {
  status?: EnquiryStatus;
  interest?: EnquiryInterest;
  business_type?: EnquiryBusinessType;
  q?: string;
  from?: string;
  to?: string;
}

/** PATCH /platform/enquiries/:id — a field left out is not changed; null clears it. */
export interface UpdateEnquiryInput {
  status?: EnquiryStatus;
  notes?: string | null;
  converted_tenant_id?: string | null;
}
